<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<video *ngIf="type === 'video'" autoplay muted controls>
  <source [appJwtSrc]="src" />
</video>

<audio *ngIf="type === 'audio'" [appJwtSrc]="src" autoplay controls></audio>
